<template>
    <div class="panel panel__overlay" :class="[classLoading, getClass()]">
        <div class="panel__menuBar" v-if="$slots.menuBar">
            <slot name="menuBar"></slot>
        </div>
        <div class="panel__head" v-if="$slots.head">
            <slot name="head"></slot>
        </div>
        <div class="panel__body" v-if="show && $slots.body">
            <slot name="body"></slot>
            <div class="panel__outService" v-if="outServiceLabel">
                <i>{{ outServiceLabel }}</i>
            </div>
        </div>
    </div>
</template>

<script>
    import { ui_LoadingMixin } from './ui-LoadingMixin';

    export default {
        name: 'ui-PanelOverlay',
        mixins: [ui_LoadingMixin],
        props: {
            panel: String,
            show: {
                type: Boolean,
                default: false,
            },
            modeHeat: {
                type: Boolean,
                default: false,
            },
            outService: {
                type: Boolean,
                default: false,
            },
            outServiceLabel: String,
            classStyles: String, // clases adicionales a incorporar
        },
        methods: {
            getClass: function() {
                var classStyles = this.panel ? `panel__${this.panel}` : '';

                if (this.show) classStyles = classStyles + ' panel--show';
                if (this.modeHeat) classStyles = classStyles + ' modeHeat';
                if (this.outService) classStyles = classStyles + ' panel--outService';
                if (this.classStyles != undefined) classStyles = `${classStyles} ${this.classStyles}`;

                return classStyles;
            },
        },
    };
</script>
